module.exports = __webpack_public_path__ + "static/media/aquila_logo.e2199106.svg";